import { GetServerSideProps, InferGetServerSidePropsType, NextPage } from 'next';

import { BottomLine } from '@/components/ui/features/audio-visual-service-page/BottomLine/BottomLine';
import { DetailsSection } from '@/components/ui/features/audio-visual-service-page/DetailsSection/DetailsSection';
import { AudioVisualHeading } from '@/components/ui/features/audio-visual-service-page/Heading/AudioVisualHeading';
import { PurpleGradientSection } from '@/components/ui/features/audio-visual-service-page/PurpleGradientSection/PurpleGradientSection';
import { ContactUsSection } from '@/components/ui/features/white-glove-service/ContactUsSection/ContactUsSection';
import { Layout } from '@/components/ui/shared/layouts/Layout/Layout';
import { AccessFrom } from '@/enums/AccessFrom';
import { queryTestimonials } from '@/queries/testimonals';
import { generateStore } from '@/utils/generateStore';
import { Hydrate } from '@/utils/swr/Hydrate';

const AudioVisualPage: NextPage<InferGetServerSidePropsType<typeof getServerSideProps>> = ({ fallback }) => {
  return (
    <Hydrate fallback={fallback}>
      <Layout accessFrom={AccessFrom.Core} navigationVariant="ghost">
        <AudioVisualHeading />
        <PurpleGradientSection />
        <DetailsSection />
        <BottomLine />
        <ContactUsSection />
      </Layout>
    </Hydrate>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const store = generateStore({ context });

  await store.fetchResources(queryTestimonials());

  return {
    props: {
      fallback: store.fallback,
    },
  };
};
export default AudioVisualPage;
